import { FC, Fragment, useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import {
  ResourceDetailsGeneralContentK8SViewSelect,
  UtilizationOrReservation,
} from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SViewSelect";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";
import { ResourceDetailsGeneralContentK8SUsageReservation } from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SUsageReservation";
import { ResourceDetailsGeneralContentK8SUsageUtilization } from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SUsageUtilization";
import { k8SResourceDetailsTargetNoUsageSelector } from "@/store/resource-details/selectors/target-resource/kubernetes/k8SResourceDetailsTargetNoUsageSelector";
import { k8SResourceDetailsTargetUsageChartDataSelector } from "@/store/resource-details/selectors/target-resource/kubernetes/k8SResourceDetailsTargetUsageChartDataSelector";
import { useGetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsQuery as useMetricsQuery } from "@/services/cloudchipr.api";

interface ResourceDetailsK8SMetricsTabContentProps {
  padding?: number;
  showMetricsTitle?: boolean;
  hideIfNoData?: boolean;
}

export const ResourceDetailsK8SMetricsTabContent: FC<
  ResourceDetailsK8SMetricsTabContentProps
> = ({ padding = 2, showMetricsTitle, hideIfNoData }) => {
  const [view, setView] = useState<UtilizationOrReservation>("reservation");

  const noUsage = useAppSelector(k8SResourceDetailsTargetNoUsageSelector);
  const resource = useAppSelector(resourceDetailsTargetResourceSelector);

  const resourceType = resource?.resourceType;
  const resourceId = resource?.provider_unique_identifier ?? "";

  const { data, isLoading } = useMetricsQuery(
    { type: resourceType ?? "ec2", resourceId: resourceId },
    { skip: !resourceType || !resourceId },
  );
  const usageChartData = useAppSelector(
    k8SResourceDetailsTargetUsageChartDataSelector,
  );
  const shouldHideMetrics =
    !data && !isLoading && !usageChartData && hideIfNoData;

  useEffect(() => {
    setView(resourceType === "kubernetes_node" ? "reservation" : "utilization");
  }, [resourceType]);

  if (shouldHideMetrics) {
    return null;
  }

  return (
    <Fragment>
      {showMetricsTitle && <Typography variant="subtitle2">Metrics</Typography>}
      <Stack spacing={1} p={padding}>
        {resourceType === "kubernetes_node" && !noUsage && (
          <ResourceDetailsGeneralContentK8SViewSelect
            view={view}
            setView={setView}
          />
        )}

        {view === "reservation" && !noUsage && (
          <ResourceDetailsGeneralContentK8SUsageReservation />
        )}

        {(view === "utilization" || noUsage) && (
          <ResourceDetailsGeneralContentK8SUsageUtilization />
        )}
      </Stack>
    </Fragment>
  );
};
